// @flow

export { DebinWithholdTaxesPage as default } from './debin-withhold-taxes-page';
